import React, { Fragment } from "react";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { Format } from "@homesusa/core";
import { useTheme } from "@homesusa/layout";

export function InfoIconButton({
  information
}: {
  information: {
    sysModifiedOn?: Date;
    createdBy: string;
    modifiedBy?: string;
    sysCreatedOn: Date;
  };
}): JSX.Element {
  const [showModal, setShowModal] = React.useState(false);
  const { variant } = useTheme();
  const title = "Entity System Information";
  return (
    <Fragment>
      <Tooltip title={title}>
        <IconButton onClick={(): void => setShowModal(true)} aria-label={title}>
          {variant === "new" ? (
            <InfoOutlined fontSize="small" />
          ) : (
            <InfoIcon />
          )}
        </IconButton>
      </Tooltip>
      <Dialog
        open={showModal}
        onClose={(): void => setShowModal(false)}
        aria-labelledby="info-dialog__title"
      >
        <DialogTitle id="info-dialog__title">{title}</DialogTitle>
        <DialogContent>
          <List>
            {!!information.createdBy && (
              <ListItem>
                <ListItemText
                  primary="Created By"
                  secondary={information.createdBy}
                />
              </ListItem>
            )}
            <ListItem>
              <ListItemText
                primary="Created On"
                secondary={Format.DateTime(information.sysCreatedOn)}
              />
            </ListItem>
            {!!information.modifiedBy && (
              <ListItem>
                <ListItemText
                  primary="Modified By"
                  secondary={information.modifiedBy}
                />
              </ListItem>
            )}
            {!!information.sysModifiedOn && (
              <ListItem>
                <ListItemText
                  primary="Modified On"
                  secondary={Format.DateTime(information.sysModifiedOn)}
                />
              </ListItem>
            )}
          </List>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
